<template>
    <div>
        <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
            :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
            @returnId="returnId" @addCreateRule="addCreateRule" pageName="intelligentAutoRebuildManage"
            @isPageSmall="isPageSmall" ref="table"></common-table>
        <el-drawer :visible.sync="showAddCreateRulePopup" :size="pageSmall ? '100%' : '55%'" direction="rtl"
            :withHeader="false">
            <div class="addCreateRuleBox ">
                <div class="createRuleTitle flex-between alcenter">
                    创建规则
                    <i class="el-icon-close" @click="closeRulePopup"></i>
                </div>
                <div class="setRuleContent">
                    <div class="oe-drawer-guide">
                        <guide-panel dense
                            title="智能重建规则说明"
                            summary="这张表单用于给表现差或长期不出单的计划建立自动重建规则。命中条件后，系统可能删除旧计划并重新搭建，是高风险自动化动作。"
                            tone="warning"
                            icon="el-icon-refresh-right"
                            :points="[
                                '适合已经有稳定投放模板、允许系统自动重搭计划的场景。',
                                '白名单里的计划不会被自动重建，建议把重点人工托管计划排除掉。',
                                '首次启用建议先灰度到少量账户，观察日志后再扩大范围。'
                            ]"
                        />
                    </div>
                    <div class="monitorWayBox">
                        <div class="pb10 ">
                            <span class="fs16 font-bold  pr10">监控方式</span>
                            <!-- <i class="el-icon-info"></i>
                            若计划存在多条监控规则，则只执行优先级最高的规则，优先级：计划>抖音号/商品>账户 -->
                        </div>
                        <div class=" flex-between">
                            <div class="way_box text-center" :class="{ 'active_way_box': activeWayBoxIndex == index }"
                                v-for="(item, index) in monitorWayList" :key="index" @click="goSelectMonitorWay(index)">
                                <div class="font-bold">
                                    {{ item.wayName }}
                                </div>
                                <div class="way_info pt10" :class="{ 'active_way_box': activeWayBoxIndex == index }">
                                    {{ item.info }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox">
                        <div class="pb10 font-bold">监控目标</div>
                        <div class="monitorTargetContent ">
                            <div>
                                <div class="flex alcenter" v-if="!activeWayBoxIndex">
                                    <el-input v-model="searchKeyWord"
                                        @clear="searchMonitorList = []; isSearching = false" clearable
                                        placeholder="搜索账户名称或ID" size="medium" class="handle-input2  mb10" />
                                    <el-button class="mb-10 fs16 mb10" type="primary" size="small"
                                        @click="goSearchMonitorList(0)">
                                        搜索
                                    </el-button>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 1">
                                    <div class="flex alcenter flex_wrap ">
                                        <el-select @focus.native.capture.stop="() => { }" class="pr10 input200 mb10"
                                            @change="getDataByAccount(0)" v-model="selectedAccount" filterable
                                            placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-date-picker class="dateSelector mb10 mr10" popper-class="datePicker2"
                                            v-model="selectData" type="daterange" align="right" unlink-panels
                                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                            :picker-options="pickerOptions" format="yyyy 年 MM 月 dd 日"
                                            @change="pickData">
                                        </el-date-picker>
                                        <el-input v-model="searchKeyWord"
                                            @clear="searchMonitorList = []; isSearching = false" clearable
                                            placeholder="搜索计划名称或ID" size="medium" class="handle-input2 mb10" />
                                        <el-button class=" fs18 mb10" type="primary" size="small"
                                            @click="goSearchMonitorList(1)">
                                            搜索
                                        </el-button>
                                    </div>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 2">
                                    <div class="flex alcenter  flex_wrap">
                                        <el-select @focus.native.capture.stop="() => { }"
                                            class="pr10 mb10 input250 mr10" @change="getDataByAccount(1)"
                                            v-model="selectedAccount" filterable placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-input v-model="searchKeyWord"
                                            @clear="searchMonitorList = []; isSearching = false" clearable
                                            placeholder="搜索抖音号名称或ID" size="medium" class="handle-input2 mb10 " />
                                        <el-button class="mb10 fs18" type="primary" size="small"
                                            @click="goSearchMonitorList(2)">
                                            搜索
                                        </el-button>
                                    </div>
                                    <div class="pb10 c_ffb563">
                                        温馨提示: 所选账户会作为规则的一部分，该规则仅对该账户下所选抖音号关联的计划生效

                                    </div>
                                </div>
                                <div v-else-if="activeWayBoxIndex == 3">
                                    <div class="flex alcenter  flex_wrap">
                                        <el-select @focus.native.capture.stop="() => { }" class="pr10 mb10 input200"
                                            @change="getdyNumberList(1)" v-model="selectedAccount" filterable
                                            placeholder="请选择账户">
                                            <el-option v-for="(item, index) in accountList" :key="index"
                                                :label="item.name" :value="item.advertiserId">
                                            </el-option>
                                        </el-select>
                                        <el-select class="pr10 mb10 input200 mr10" @change="getProductList"
                                            v-model="selectedDYNumber" placeholder="请选择抖音号">
                                            <el-option v-for="(item, index) in dyNumberList" :key="index"
                                                :label="item.name" :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-input v-model="searchKeyWord"
                                            @clear="searchMonitorList = []; isSearching = false" clearable
                                            placeholder="搜索商品名称或ID" size="medium" class="handle-input2  mb10 " />
                                        <el-button class="mb10 fs18" type="primary" size="small"
                                            @click="goSearchMonitorList(3)">
                                            搜索
                                        </el-button>
                                    </div>
                                    <div class="pb10 c_ffb563">
                                        温馨提示: 所选账户会作为规则的一部分，该规则仅对该账户下所选商品关联的计划生效
                                    </div>
                                </div>
                            </div>
                            <div class="selectAccountBox">
                                <div class="selectTitleBox flex alcenter">
                                    <div class="leftTitle flex alcenter">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                            @change="handleCheckAllChange">
                                        </el-checkbox>
                                        <span class="pr5 pl10">请选择{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ? '计划'
                                            :
                                            activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户' }}</span>
                                        <span class=" pr5 fs12" v-if="monitorList.length">
                                            ({{ isSearching ? searchMonitorList.length : monitorList.length
                                            }})
                                        </span>
                                        <el-tooltip class="item" effect="dark"
                                            :content="activeWayBoxIndex ? '最多展示前100条，如果列表没有某条数据，请使用搜索减小范围' : '最多展示前200条，如果列表没有某条数据，请使用搜索减小范围'"
                                            placement="top">
                                            <i class="el-icon-question mt5"></i>
                                        </el-tooltip>
                                    </div>
                                    <div class="rightTitle flex-between">
                                        <div class="flex alcenter">
                                            已选 <span v-if="selectedMonitorList.length">( {{ selectedMonitorList.length
                                                }}
                                                )</span>
                                            <span v-else>{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ? '计划'
                                                :
                                                activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户' }}</span>
                                        </div>
                                        <div class="c_primary" v-if="selectedMonitorList.length"
                                            @click="deleteSelectedMonitorList('')">
                                            清空
                                        </div>
                                    </div>
                                </div>
                                <div class="selectContentBox">
                                    <div class="flex">
                                        <div class="left" v-loading="loading">
                                            <el-checkbox-group v-model="checkedAccount"
                                                @change="handleCheckedCitiesChange">
                                                <div class="flex alcenter  pb20"
                                                    v-for="(item, index) in isSearching ? searchMonitorList : monitorList"
                                                    :key="index">
                                                    <el-checkbox :label="item" class="checkBox">
                                                        <div class="pl5 flex alcenter">
                                                            <img class="productImg" :class="pageSmall ? 'mr5' : 'mr10'"
                                                                v-if="activeWayBoxIndex == 3" :src="item.img" alt="">
                                                            <div>
                                                                <div
                                                                    :class="pageSmall ? 'overflow1_120 fs16' : 'overflow1_300 fs18'">
                                                                    {{ item.name ||
                                                                        item.productName }}</div>
                                                                <div class="c_999 "
                                                                    :class="pageSmall ? 'fs12' : ' fs14'">
                                                                    ID:{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ?
                                                                        item.adId : activeWayBoxIndex == 2 ?
                                                                            item.id
                                                                            : item.id : item.advertiserId }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </el-checkbox>
                                                </div>
                                            </el-checkbox-group>
                                            <div class="pt50 nodata flex-center"
                                                v-if="isSearching ? !searchMonitorList.length : !monitorList.length">
                                                暂无数据
                                            </div>
                                        </div>
                                        <div class="left p5" v-loading="loading">
                                            <div class="flex-between alcenter selectedAccountBox pb20 mb10"
                                                v-for="(item, index) in selectedMonitorList" :key="index">
                                                <div class="pl5 flex alcenter">
                                                    <img class="productImg" :class="pageSmall ? 'mr5' : 'mr10'"
                                                        v-if="activeWayBoxIndex == 3" :src="item.img" alt="">
                                                    <div class="">
                                                        <div
                                                            :class="pageSmall ? 'overflow1_100 fs16' : 'overflow1_300 fs18'">
                                                            {{ item.name || item.productName
                                                            }}
                                                        </div>
                                                        <div class="c_999 "
                                                            :class="pageSmall ? ' overflow1_100 fs12' : 'overflow1_300 fs14'">
                                                            ID:{{ activeWayBoxIndex ? activeWayBoxIndex == 1 ?
                                                                item.adId : activeWayBoxIndex == 2 ? item.id
                                                                    : item.id : item.advertiserId }}
                                                        </div>
                                                    </div>

                                                </div>
                                                <i class="el-icon-error" @click="deleteSelectedMonitorList(index)"></i>
                                            </div>
                                            <div class="pt50 nodata flex-center" v-if="!selectedMonitorList.length">
                                                暂无数据
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox ">
                        <div class="pb10 fs18 font-bold">计划白名单</div>
                        <div class="monitorTargetContent ">
                            <el-select v-model="planWhiteList" multiple filterable allow-create default-first-option
                                clearable collapse-tags class="input400 input_h35"
                                @change="planWhiteList = normalizePlanWhiteList(planWhiteList)"
                                placeholder="输入计划ID后回车确认；已加载计划会自动出现在下拉中">
                                <el-option v-for="item in planWhiteListOptions" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <div class="pt10 c_999">
                                命中白名单的计划不会被当前规则处理；未加载到的计划也可以直接输入计划ID。
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox ">
                        <div class="pb10 fs18 font-bold">执行内容</div>
                        <div class="monitorTargetContent ">
                            <div class=" input150 content_box1">
                                <div class="flex  flex_wrap">
                                    <el-switch class="mr10" :disabled="!monitor2"
                                        :style="{ 'transform: scale(1.3);': !pageSmall }" v-model="monitor1">
                                    </el-switch>
                                    <div v-if="monitor1">
                                        <div class="pb10">不出单计划自动删除并重新搭建</div>
                                        <div class="flex alcenter pb10">
                                            计划保持开启状态下，最近连续
                                            <div class="relative ml10 mr10">
                                                <el-input min="1" max="10" type="number"
                                                    @blur="noOrderContinuousDays < 1 ? noOrderContinuousDays = 1 : null"
                                                    v-model="noOrderContinuousDays" placeholder="请输入" suffix-icon="天"
                                                    size="medium" />
                                                <div class="yuan_box">
                                                    天
                                                </div>
                                            </div>
                                            累计整体成交订单数≤
                                            <div class="relative ml10">
                                                <el-input min="0" v-model="noOrderTotalOrders" type="number"
                                                    placeholder="请输入" suffix-icon="单" size="medium" />
                                                <div class="yuan_box">
                                                    单
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex alcenter pb10">
                                            删除计划并按照原参数重新搭建计划
                                            <el-switch class="mr10 ml10"
                                                :style="{ 'transform: scale(1.3);': !pageSmall }"
                                                v-model="noOrderRebuildWithOriginalParams">
                                            </el-switch>
                                            在原参数基础上，整体ROI目标
                                            <el-select class="input_h35 ml10 " v-model="noOrderRoiAdjustType"
                                                placeholder="请选择">
                                                <el-option v-for="(item, index) in reduceList" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                            <div class="relative ">
                                                <el-input class="w150 input150 input_h35" v-model="noOrderRoiTarget"
                                                    min="0" type="number" placeholder="请输入" suffix-icon="%"
                                                    size="medium" />
                                                <div class="yuan_box" v-if="
                                                    noOrderRoiAdjustType == '百分比降低'">
                                                    %
                                                </div>
                                            </div>

                                        </div>
                                        <div class="flex  pt10 ">
                                            <span class="pr10 pt5 ">
                                                执行时段
                                            </span>
                                            <div>
                                                <div class="flex alcenter">
                                                    <div class="timePeriodBox" @click="activeTimePeriodBox = 0"
                                                        :class="{ 'activeTimePeriodBox': !activeTimePeriodBox }">
                                                        不限
                                                    </div>
                                                    <div class="timePeriodBox" @click="activeTimePeriodBox = 1"
                                                        :class="{ 'activeTimePeriodBox': activeTimePeriodBox }">
                                                        指定时段
                                                    </div>
                                                </div>
                                                <div class="pt10 " v-if="activeTimePeriodBox && !pageSmall">
                                                    <table border class="yl-time-range-table">
                                                        <thead class="table_head">
                                                            <tr>
                                                                <th colspan="24">00:00 - 12:00</th>
                                                                <th colspan="24">12:00 - 24:00</th>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" v-for="(item, index) in 24"
                                                                    :key="index"> {{
                                                                        item -
                                                                        1 }}</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr @mouseleave="handleMouseLeave(0)">
                                                                <td colspan="1" v-for="(item, index) in 48"
                                                                    :key="index">
                                                                    <div class="time_select_box" :class="{
                                                                        'time_select_box_active': noOrderExecuteTimeSegments.includes(item),
                                                                        'time_select_box_inactive': !noOrderExecuteTimeSegments.includes(item),
                                                                        'time_select_box_active2': draggedElements.includes(item)
                                                                    }" @mousedown.stop="onMouseDown(item, $event)"
                                                                        @mousemove.stop="onMouseMove(item, $event)"
                                                                        @mouseup.stop="onMouseUp(item)">
                                                                        <div class="trigger"
                                                                            style="display: inline-block;">
                                                                            <div class="yl-time-range-triger"></div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                                <div class="pt10 " v-if="activeTimePeriodBox && pageSmall">
                                                    <table border class="yl-time-range-table">
                                                        <thead class="table_head">
                                                            <tr>
                                                                <th colspan="24">00:00 - 12:00</th>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" v-for="(item, index) in 12"
                                                                    :key="index"> {{
                                                                        item -
                                                                        1 }}</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr @mouseleave="handleMouseLeave(0)">
                                                                <td colspan="1" v-for="(item, index) in 24"
                                                                    :key="index">
                                                                    <div class="time_select_box" :class="{
                                                                        'time_select_box_active': noOrderExecuteTimeSegments.includes(item),
                                                                        'time_select_box_inactive': !noOrderExecuteTimeSegments.includes(item),
                                                                        'time_select_box_active2': draggedElements.includes(item)
                                                                    }" @mousedown.stop="onMouseDown(item, $event)"
                                                                        @mousemove.stop="onMouseMove(item, $event)"
                                                                        @mouseup.stop="onMouseUp(item)">
                                                                        <div class="trigger"
                                                                            style="display: inline-block;">
                                                                            <div class="yl-time-range-triger"></div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <table border class="yl-time-range-table">
                                                        <thead class="table_head">
                                                            <tr>
                                                                <th colspan="24">12:00 - 24:00</th>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" v-for="(item, index) in 12"
                                                                    :key="index"> {{
                                                                        item +
                                                                        11 }}</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr @mouseleave="handleMouseLeave(0)">
                                                                <td colspan="1" v-for="(item, index) in 24"
                                                                    :key="index">
                                                                    <div class="time_select_box" :class="{
                                                                        'time_select_box_active': noOrderExecuteTimeSegments.includes(item + 24),
                                                                        'time_select_box_inactive': !noOrderExecuteTimeSegments.includes(item + 24),
                                                                        'time_select_box_active2': draggedElements.includes(item + 24)
                                                                    }" @mousedown.stop="onMouseDown(item + 24, $event)"
                                                                        @mousemove.stop="onMouseMove(item + 24, $event)"
                                                                        @mouseup.stop="onMouseUp(item + 24)">
                                                                        <div class="trigger"
                                                                            style="display: inline-block;">
                                                                            <div class="yl-time-range-triger"></div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="c_ff3939 pt10"
                                                    v-if="!noOrderExecuteTimeSegments.length && activeTimePeriodBox">
                                                    请选择时间
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class=" input150 mt30 content_box1">
                                <div class="flex  flex_wrap">
                                    <el-switch class="mr10" :disabled="!monitor1"
                                        :style="{ 'transform: scale(1.3);': !pageSmall }" v-model="monitor2">
                                    </el-switch>
                                    <div v-if="monitor2">
                                        <div class="pb10">不消耗计划自动删除并重新搭建</div>
                                        <div class="flex alcenter pb10">
                                            计划保持开启状态下，最近连续
                                            <div class="relative ml10 mr10">
                                                <el-input min="1" max="10" type="number"
                                                    @blur="noConsumeContinuousDays < 1 ? noConsumeContinuousDays = 1 : null"
                                                    v-model="noConsumeContinuousDays" placeholder="请输入" suffix-icon="天"
                                                    size="medium" />
                                                <div class="yuan_box">
                                                    天
                                                </div>
                                            </div>
                                            累计整体消耗≤
                                            <div class="relative ml10">
                                                <el-input min="0" v-model="noConsumeTotalAmount" type="number"
                                                    placeholder="请输入" suffix-icon="元" size="medium" />
                                                <div class="yuan_box">
                                                    元
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex alcenter pb10">
                                            删除计划并按照原参数重新搭建计划
                                            <el-switch class="mr10 ml10"
                                                :style="{ 'transform: scale(1.3);': !pageSmall }"
                                                v-model="noConsumeRebuildWithOriginalParams">
                                            </el-switch>
                                            在原参数基础上，整体ROI目标
                                            <el-select class="input_h35 ml10 " v-model="noConsumeRoiAdjustType"
                                                placeholder="请选择">
                                                <el-option v-for="(item, index) in reduceList" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                            <div class="relative ">
                                                <el-input class="w150 input150 input_h35" v-model="noConsumeRoiTarget"
                                                    min="0" type="number" placeholder="请输入" suffix-icon="%"
                                                    size="medium" />
                                                <div class="yuan_box" v-if="
                                                    noConsumeRoiAdjustType == '百分比降低'">
                                                    %
                                                </div>
                                            </div>

                                        </div>
                                        <div class="flex  pt10 " v-if="monitor2">
                                            <span class="pr10 pt5 ">
                                                执行时段
                                            </span>
                                            <div>
                                                <div class="flex alcenter">
                                                    <div class="timePeriodBox" @click="activeTimePeriodBox2 = 0"
                                                        :class="{ 'activeTimePeriodBox': !activeTimePeriodBox2 }">
                                                        不限
                                                    </div>
                                                    <div class="timePeriodBox" @click="activeTimePeriodBox2 = 1"
                                                        :class="{ 'activeTimePeriodBox': activeTimePeriodBox2 }">
                                                        指定时段
                                                    </div>
                                                </div>
                                                <div class="pt10 " v-if="activeTimePeriodBox2 && !pageSmall">
                                                    <table border class="yl-time-range-table">
                                                        <thead class="table_head">
                                                            <tr>
                                                                <th colspan="24">00:00 - 12:00</th>
                                                                <th colspan="24">12:00 - 24:00</th>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" v-for="(item, index) in 24"
                                                                    :key="index"> {{
                                                                        item -
                                                                        1 }}</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr @mouseleave="handleMouseLeave(0)">
                                                                <td colspan="1" v-for="(item, index) in 48"
                                                                    :key="index">
                                                                    <div class="time_select_box" :class="{
                                                                        'time_select_box_active': noConsumeExecuteTimeSegments.includes(item),
                                                                        'time_select_box_inactive': !noConsumeExecuteTimeSegments.includes(item),
                                                                        'time_select_box_active2': draggedElements2.includes(item)
                                                                    }" @mousedown.stop="onMouseDown(item, $event, 1)"
                                                                        @mousemove.stop="onMouseMove(item, $event, 1)"
                                                                        @mouseup.stop="onMouseUp(item, 1)">
                                                                        <div class="trigger"
                                                                            style="display: inline-block;">
                                                                            <div class="yl-time-range-triger"></div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </div>
                                                <div class="pt10 " v-if="activeTimePeriodBox2 && pageSmall">
                                                    <table border class="yl-time-range-table">
                                                        <thead class="table_head">
                                                            <tr>
                                                                <th colspan="24">00:00 - 12:00</th>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" v-for="(item, index) in 12"
                                                                    :key="index"> {{
                                                                        item -
                                                                        1 }}</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr @mouseleave="handleMouseLeave(0)">
                                                                <td colspan="1" v-for="(item, index) in 24"
                                                                    :key="index">
                                                                    <div class="time_select_box" :class="{
                                                                        'time_select_box_active': noConsumeExecuteTimeSegments.includes(item),
                                                                        'time_select_box_inactive': !noConsumeExecuteTimeSegments.includes(item),
                                                                        'time_select_box_active2': draggedElements2.includes(item)
                                                                    }" @mousedown.stop="onMouseDown(item, $event, 1)"
                                                                        @mousemove.stop="onMouseMove(item, $event, 1)"
                                                                        @mouseup.stop="onMouseUp(item, 1)">
                                                                        <div class="trigger"
                                                                            style="display: inline-block;">
                                                                            <div class="yl-time-range-triger"></div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <table border class="yl-time-range-table">
                                                        <thead class="table_head">
                                                            <tr>
                                                                <th colspan="24">12:00 - 24:00</th>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="2" v-for="(item, index) in 12"
                                                                    :key="index"> {{
                                                                        item +
                                                                        11 }}</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr @mouseleave="handleMouseLeave(0)">
                                                                <td colspan="1" v-for="(item, index) in 24"
                                                                    :key="index">
                                                                    <div class="time_select_box" :class="{
                                                                        'time_select_box_active': noConsumeExecuteTimeSegments.includes(item + 24),
                                                                        'time_select_box_inactive': !noConsumeExecuteTimeSegments.includes(item + 24),
                                                                        'time_select_box_active2': draggedElements2.includes(item + 24)
                                                                    }" @mousedown.stop="onMouseDown(item + 24, $event, 1)"
                                                                        @mousemove.stop="onMouseMove(item + 24, $event, 1)"
                                                                        @mouseup.stop="onMouseUp(item + 24, 1)">
                                                                        <div class="trigger"
                                                                            style="display: inline-block;">
                                                                            <div class="yl-time-range-triger"></div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="c_ff3939 pt10"
                                                    v-if="!noConsumeExecuteTimeSegments.length && activeTimePeriodBox2">
                                                    请选择时间
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="monitorTargetBox ">
                        <div class="flex alcenter pb10">
                            <div class=" fs18 font-bold">重建设置</div>
                            <div class="flex pt5 pl20 alcenter">
                                <el-switch class="mr10" :style="{ 'transform: scale(1.3);': !pageSmall }"
                                    v-model="isPromotionEnabled">
                                </el-switch>
                                已暂停投放的计划不参与执行
                            </div>
                        </div>
                        <div class="monitorTargetContent ">
                            <div class="flex alcenter  pt20">
                                <i class="el-icon-info c_primary mr5"></i>
                                单账户每日可创建计划数存在上限，若账户今日无法再创建计划，该账户今日将不会再执行删除重建，次日恢复执行
                                单账户每日最多重建
                                <div class="relative ml10 mr10">
                                    <el-input min="0" v-model="maxDailyRebuildPerAccount" placeholder="请输入"
                                        suffix-icon="" size="medium" />
                                    <div class="yuan_box">
                                        条
                                    </div>
                                </div>计划
                            </div>
                        </div>

                    </div>
                    <div class="monitorTargetBox ">
                        <div class="pb10 fs18 font-bold">通知设置</div>
                        <div class="monitorTargetContent ">
                            <div class="flex   pt20">
                                <span class="pr20 ">
                                    通知方式
                                </span>
                                <div>
                                    <el-checkbox :style="{ 'transform: scale(1.2);': !pageSmall }" v-model="wxNotice">
                                        微信通知
                                    </el-checkbox>
                                    <div v-if="!wxNotice" class="c_ff3939 pt10">
                                        请选择通知方式
                                    </div>
                                </div>
                            </div>
                            <div class="flex  pt20" v-if="wxNotice">
                                <span class="pr10 pt10">
                                    微信联系人
                                </span>
                                <div>
                                    <div class="pb10">
                                        <el-select class="" :class="pageSmall ? 'w200 input200' : 'w400 input400'"
                                            multiple v-model="wxContracts" filterable placeholder="请选择联系人">
                                            <el-option v-for="item in wxContractsOptions" :key="item.wechatName"
                                                :label="item.wechatName" :value="item.openId">
                                            </el-option>
                                        </el-select>
                                        <span class="pl20 c_primary" @click="goAddContrats">添加联系人</span>
                                    </div>
                                    <div class="flex alcenter flex_wrap ">
                                        <el-switch class="mr10 mb10" :style="{ 'transform: scale(1.2);': !pageSmall }"
                                            v-model="isLimitWXNotice">
                                        </el-switch>
                                        <div class="pb10">限制通知频率，每条计划</div>
                                        <el-select v-model="wxNoticeTimeValue" :disabled="!isLimitWXNotice"
                                            class="ml5 input150  mb10" placeholder="请选择">
                                            <el-option v-for="(item, index) in wxNoticeTimeList" :key="index"
                                                :label="item.name" :value="item.value">
                                            </el-option>
                                        </el-select>
                                        <div class="pb10">内最多通知一次</div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="oe-drawer-section oe-drawer-section--bottom">
                        <span class="oe-drawer-form-label" style="display:inline-block;width:auto;margin-right:8px;">监控状态</span>
                        <el-select class="input250 w250" v-model="monitorStatus" placeholder="请选择">
                            <el-option v-for="item in monitorStatusList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">规则名称</span>
                        <el-input class="input250 w250" v-model="ruleName" placeholder="请输入规则名称" />
                    </div>
                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">请选择代理</span>
                        <el-select size="medium" v-model="selectAgentId" placeholder="请选择代理" clearable filterable>
                            <el-option v-for="(option, index) in agentList" :key="index" :label="option.username"
                                :value="option.id" />
                        </el-select>
                    </div>
                </div>
                <div class="drawer_footer flex-end alcenter">
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="closeRulePopup">
                        取消
                    </el-button>
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="goAddRule">
                        确定
                    </el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import GuidePanel from "@/components/GuidePanel/GuidePanel";
import {
    buildMonitorObjectInfo,
    buildPlanWhiteListOptions,
    normalizePlanWhiteList,
    parseMonitorObjectInfo,
} from "@/utils/smartRoiRuleFormHelper";
// import request from "@/utils/axios";
// import message from "@/utils/message";

export default {
    name: 'intelligentAutoRebuildManage',
    components: { CommonTable, GuidePanel },
    data() {
        return {
            agentList: [],
            selectAgentId: '',
            loading: false,
            editData: {},
            selectedDYNumber: '',
            selectedAccount: '',
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setHours(0, 0, 0, 0);  // 今天00:00:00
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const end = new Date();
                        end.setDate(end.getDate() - 1);
                        end.setHours(23, 59, 59, 999);  // 昨天23:59:59.999
                        const start = new Date(end);
                        start.setHours(0, 0, 0, 0);  // 昨天00:00:00
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近3天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 2);  // 3天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近7天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 6);  // 7天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近15天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 14);  // 15天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '近30天',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(start.getDate() - 29);  // 30天前（含今天）
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '上周',
                    onClick(picker) {
                        const today = new Date();
                        const day = today.getDay(); // 本周的第几天（0=周日）
                        const diff = day === 0 ? 6 : day - 1; // 到上周一的天数差

                        const end = new Date(today);
                        end.setDate(today.getDate() - diff - 1); // 上周日
                        end.setHours(23, 59, 59, 999);

                        const start = new Date(end);
                        start.setDate(end.getDate() - 6); // 上周一
                        start.setHours(0, 0, 0, 0);

                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setDate(1);  // 本月1号
                        start.setHours(0, 0, 0, 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '上月',
                    onClick(picker) {
                        const end = new Date();
                        end.setMonth(end.getMonth(), 0);  // 上月最后一天
                        end.setHours(23, 59, 59, 999);

                        const start = new Date(end);
                        start.setDate(1);  // 上月1号
                        start.setHours(0, 0, 0, 0);

                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            selectData: '',
            dyNumberList: [],
            isSearching: false,
            activeWayBoxIndex: 0,
            searchKeyWord: '',
            monitorWayList: [
                {
                    wayName: '账户',
                    info: '监控账户下所有计划'
                },
                {
                    wayName: '计划',
                    info: '监控指定计划'
                },
                {
                    wayName: '抖音号',
                    info: '监控账户x抖音号下的计划'
                },
                {
                    wayName: '商品',
                    info: '监控账户x商品下的计划'
                },
            ],
            checkAll: false,
            checkedAccount: [],
            monitorList: [],
            accountList: [],
            selectedMonitorList: [],
            planWhiteList: [],
            planWhiteListOptions: [],


            // 执行内容
            monitor1: true,
            monitor2: true,


            // 1
            noOrderContinuousDays: 1,
            noOrderTotalOrders: 0,
            noOrderRebuildWithOriginalParams: false,
            noOrderRoiAdjustType: '降低',
            noOrderRoiTarget: '',



            // 2
            noConsumeContinuousDays: 1,
            noConsumeTotalAmount: 0,
            noConsumeRebuildWithOriginalParams: false,
            noConsumeRoiAdjustType: '降低',
            noConsumeRoiTarget: '',
            reduceList: ['百分比降低', '降低', '修改为'],




            // 执行时段
            activeTimePeriodBox: 0,
            activeTimePeriodBox2: 0,
            noOrderExecuteTimeSegments: [],
            noConsumeExecuteTimeSegments: [],
            isPromotionEnabled: true,
            maxDailyRebuildPerAccount: 500,

            wxNotice: true,
            wxContracts: [],
            wxContractsOptions: [],
            isLimitWXNotice: false,
            wxNoticeTimeValue: 30,
            wxNoticeTimeList: [{
                name: '每30分钟',
                value: 30
            }, {
                name: '每1小时',
                value: 60
            }, {
                name: '每3小时',
                value: 180
            }, {
                name: '每6小时',
                value: 360
            }],

            // 监控状态
            monitorStatus: '启用',
            monitorStatusList: ['启用', '停用'],

            // 规则名称
            ruleName: '',


            isIndeterminate: true,
            showAddCreateRulePopup: false,
            selectIds: [],
            searchs: [
                // {
                //     name: 'aweMeId',
                //     placeholder: '营销目标',
                //     type: 'select',
                //     select: true,
                //     // selectUrl: '/oceanEngineAdvertiser/getAllInfoAndDouYin',
                //     selectData: [],
                // },
                {
                    name: 'monitorStatus',
                    placeholder: '监控状态',
                    type: 'select',
                    select: true,
                    // selectUrl: '/oceanEngineAdvertiser/getAllInfo',
                    selectData: [],
                    selectValue: [{
                        value: '关闭',
                        key: 0
                    }, {
                        value: '开启',
                        key: 1
                    }]
                }, {
                    name: 'createPerson',
                    placeholder: '创建人',
                    type: 'select',
                    select: true,
                    selectUrl: '/agent/getAll',
                    selectData: [],
                },
                {
                    name: 'ruleName',
                    placeholder: '规则名称',
                    type: 'input'
                }],
            permission: {
                add: 'launchTheProduct:add',
                update: 'launchTheProduct:update',
                delete: 'launchTheProduct:delete',
                deleteBatch: 'launchTheProduct:deleteBatch'
            },
            url: {
                get: '/smartRoiRules/listByCondition?intelligentRegulationType=4',
                // add: '/launchTheProduct/add',
                // update: '/launchTheProduct/update',
                // delete: '/launchTheProduct/delete',
                // delete_batch: '/launchTheProduct/deleteBatch',
                // status: '/launchTheProduct/status',
            },
            tableColumns: [{
                field: 'status',  // 字段名
                label: '状态',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                status: true,  // 是否展示
            }, {
                field: 'ruleName',  // 字段名
                label: '规则名称',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            },
            //  {
            //     field: 'marketingObjectives',  // 字段名
            //     label: '营销目标',  // 字段显示名称
            //     sort: false,  // 是否排序
            //     show: true,  // 是否展示
            // },
            {
                field: 'monitorList',  // 字段名
                label: '监控对象',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                tableType: 'monitorList'
            },
            {
                field: 'monitorWay',  // 字段名
                label: '监控方式',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                tableType: 'monitorMode'
            }, {
                field: 'ruleInfo',  // 字段名
                label: '规则详情',  // 字段显示名称
                toHtml: true,
                center: false,
                sort: false,  // 是否排序
                show: true,  // 是否展示
                width: 600
            },
            {
                field: 'createPerson',  // 字段名
                label: '创建人',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,
            }
            ],
            formFields: {
                addTitle: '添加',
                updateTitle: '修改',
                model: [
                    {
                        field: 'id',  // 字段名
                        label: 'ID',  // 字段显示名称
                        type: 'input',
                        add: false,  // 是否添加
                        update: true
                    },
                    {
                        field: 'agentId',  // 字段名
                        label: 'agentId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入agentId',
                        rules: [
                            { required: true, message: 'agentId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'userId',  // 字段名
                        label: 'userId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入userId',
                        rules: [
                            { required: true, message: 'userId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'advertiserId',  // 字段名
                        label: 'advertiserId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入advertiserId',
                        rules: [
                            { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'aweMeId',  // 字段名
                        label: 'aweMeId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入aweMeId',
                        rules: [
                            { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productId',  // 字段名
                        label: 'productId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productId',
                        rules: [
                            { required: true, message: 'productId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productName',  // 字段名
                        label: 'productName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productName',
                        rules: [
                            { required: true, message: 'productName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'img',  // 字段名
                        label: 'img',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入img',
                        rules: [
                            { required: true, message: 'img不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'tag',  // 字段名
                        label: 'tag',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入tag',
                        rules: [
                            { required: true, message: 'tag不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'categoryName',  // 字段名
                        label: 'categoryName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入categoryName',
                        rules: [
                            { required: true, message: 'categoryName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'sellNum',  // 字段名
                        label: 'sellNum',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入sellNum',
                        rules: [
                            { required: true, message: 'sellNum不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'grayReason',  // 字段名
                        label: 'grayReason',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入grayReason',
                        rules: [
                            { required: true, message: 'grayReason不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'squareImageList',  // 字段名
                        label: 'squareImageList',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入squareImageList',
                        rules: [
                            { required: true, message: 'squareImageList不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelId',  // 字段名
                        label: 'channelId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelId',
                        rules: [
                            { required: true, message: 'channelId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelType',  // 字段名
                        label: 'channelType',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelType',
                        rules: [
                            { required: true, message: 'channelType不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    },
                ]
            },
            operate: [{
                icon: 'el-icon-edit',
                type: 'text',
                text: '编辑',
                handle: (row) => {
                    console.log(row)
                    this.showAddCreateRulePopup = true
                    this.editData.id = row.id
                    this.editData.monitoringTime = row.executeContent.monitoringTime
                    this.monitorStatus = row.status ? '启用' : '停用'
                    this.activeWayBoxIndex = row.monitorType - 1
                    if (!this.activeWayBoxIndex) {
                        this.monitorList = this.accountList
                        let arr = []
                        this.accountList.forEach((obj) => {
                            if (row.monitorObject.includes(obj.advertiserId)) {
                                arr.push(obj)
                            }
                        })
                        if (arr.length) {
                            this.checkedAccount = arr
                            this.handleCheckedCitiesChange(arr)
                        }
                        if (row.executeContent.monitorObjectInfo) {
                            const { planWhiteList } = parseMonitorObjectInfo(row.executeContent.monitorObjectInfo)
                            this.planWhiteList = normalizePlanWhiteList(planWhiteList)
                            this.mergePlanWhiteListOptions(
                                this.planWhiteList.map(value => ({ adId: value, name: value }))
                            )
                        }
                    } else {
                        if (row.monitorAdvertiserId) {
                            this.monitorAdvertiserId = row.monitorAdvertiserId
                            if (this.accountList.length) {
                                this.selectedAccount = JSON.parse(this.monitorAdvertiserId)
                            }
                            if (row.executeContent.monitorObjectInfo) {
                                this.restoreMonitorObjectInfo(row.executeContent.monitorObjectInfo)
                            }
                            this.monitorList = []
                            if (this.activeWayBoxIndex == 1) {
                                this.getDataByAccount(0)
                            } else if (this.activeWayBoxIndex == 2) {
                                this.getDataByAccount(1)
                            }

                        }
                        console.log('11111111', this.activeWayBoxIndex, this.selectedAccount)
                    }
                    if (row.executeContent.noOrderContinuousDays) {
                        this.monitor1 = true
                        this.noOrderContinuousDays = row.executeContent.noOrderContinuousDays
                        this.noOrderTotalOrders = row.executeContent.noOrderTotalOrders
                        this.noOrderRebuildWithOriginalParams = row.executeContent.noOrderRebuildWithOriginalParams
                        this.noOrderRoiAdjustType = row.executeContent.noOrderRoiAdjustType
                        this.noOrderRoiTarget = row.executeContent.noOrderRoiTarget
                        if (row.executeContent.noOrderExecuteTimeSegments.length) {
                            this.activeTimePeriodBox = 1
                            this.noOrderExecuteTimeSegments = row.executeContent.noOrderExecuteTimeSegments
                        }
                    } else {
                        this.monitor1 = false
                    }


                    if (row.executeContent.noConsumeContinuousDays) {
                        this.monitor2 = true
                        this.noConsumeContinuousDays = row.executeContent.noConsumeContinuousDays
                        this.noConsumeTotalAmount = row.executeContent.noConsumeTotalAmount
                        this.noConsumeRebuildWithOriginalParams = row.executeContent.noConsumeRebuildWithOriginalParams
                        this.noConsumeRoiAdjustType = row.executeContent.noConsumeRoiAdjustType
                        this.noConsumeRoiTarget = row.executeContent.noConsumeRoiTarget

                        if (row.executeContent.noConsumeExecuteTimeSegments.length) {
                            this.activeTimePeriodBox2 = 1
                            this.noConsumeExecuteTimeSegments = row.executeContent.noConsumeExecuteTimeSegments
                        }
                    } else {
                        this.monitor2 = false
                    }
                    this.isPromotionEnabled = row.executeContent.isPromotionEnabled
                    this.maxDailyRebuildPerAccount = row.executeContent.maxDailyRebuildPerAccount
                    this.ruleName = row.ruleName
                    this.selectAgentId = row.userId
                    this.wxContracts = row.noticeConfig && row.noticeConfig.wxNumber
                    if (row.noticeConfig && row.noticeConfig.interval) {
                        this.isLimitWXNotice = true
                        this.wxNoticeTimeValue = row.noticeConfig.interval
                    }

                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '删除',
                handle: (row) => {
                    console.log(row)
                    console.log(row)
                    this.$axios.post({
                        url: 'smartRoiRules/delete/' + row.id,
                        success: (res) => {
                            // this.loading = false
                            console.log('333', res)
                            if (res.code == 0) {
                                this.$message.success('删除成功')
                                // this.showAddCreateRulePopup = false
                                this.$refs.table.getData()
                            } else {
                                // this.$message.error(res.msg || '出错了')

                            }
                        },
                        error: () => {
                            this.loading = false
                            this.$message.error('出错了')
                        },
                    })
                }
            }, {
                icon: 'el-icon-tickets',
                type: 'text',
                text: '日志',
                handle: (row) => {
                    console.log(row)

                    this.$router.push({
                        path: '/qdd/admin/SmartRoiRuleLogs.html',
                        query: { id: row.id, getLog: true }
                    })
                }
            }],
            buttons: [
                {

                }
            ],
            // 元素拖拽
            draggedElements: [],
            draggedElements2: [],
            isDragging: false,
            startX: 0,
            startY: 0,
            dragThreshold: 2,
            isMouseDown: false,
            pageSmall: false
        }
    },
    mounted() {
        this.getADAccountList()
        this.getWxcontractsList()
        this.getAgentList()
    },
    methods: {
        normalizePlanWhiteList,
        getAgentList() {
            this.$axios.post({
                url: '/agent/getAll',
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.agentList = res.data
                        console.log('333', this.agentList)

                    } else {
                        this.$message.error(res.msg || '出错了')

                    }
                    //
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        goAddContrats() {
            this.showAddCreateRulePopup = false
            setTimeout(() => {
                this.$router.push({
                    path: '/qdd/admin/contacts.html',
                })
            }, 1)
        },
        isPageSmall(data) {
            this.pageSmall = data;
            console.log(this.pageSmall)
        },
        mergePlanWhiteListOptions(list = []) {
            const nextOptions = buildPlanWhiteListOptions(list)
            if (!nextOptions.length) {
                return
            }
            const optionMap = new Map(this.planWhiteListOptions.map(item => [item.value, item]))
            nextOptions.forEach((item) => {
                optionMap.set(item.value, item)
            })
            this.planWhiteListOptions = Array.from(optionMap.values())
        },
        restoreMonitorObjectInfo(raw) {
            const { selectedMonitorList, planWhiteList } = parseMonitorObjectInfo(raw)
            this.selectedMonitorList = selectedMonitorList
            this.planWhiteList = normalizePlanWhiteList(planWhiteList)
            this.mergePlanWhiteListOptions(
                this.planWhiteList.map(value => ({ adId: value, name: value }))
            )
        },
        getWxcontractsList() {
            this.$axios.post({
                url: '/wechatUser/getAll',
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.wxContractsOptions = res.data
                    } else {
                        this.$message.error(res.msg || '出错了')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        onMouseDown(item, e, type) {
            this.isMouseDown = true
            this.startX = e.clientX
            this.startY = e.clientY
            if (type) {
                this.draggedElements2 = [item]
            } else {
                this.draggedElements = [item]
            }
            console.log(this.startX, this.startY)
        },
        onMouseMove(item, e, type) {
            if (!this.isMouseDown) return
            if (!this.isDragging) {
                console.log(item, e)
                // 计算移动距离
                const dx = Math.abs(e.clientX - this.startX);
                const dy = Math.abs(e.clientY - this.startY);
                console.log(dx, dy, 'handleGlobalMouseMove')

                // 超过阈值则标记为拖拽
                if (dx >= this.dragThreshold || dy >= this.dragThreshold) {
                    this.isDragging = true;
                }
            }
            let arr = type ? this.draggedElements2 : this.draggedElements
            if (this.isDragging && !arr.includes(item)) {
                arr.push(item);
                if (arr.length >= 2) {
                    // 获取当前首尾元素
                    const first = arr[0];
                    const last = arr[arr.length - 1];

                    // 计算范围的起始和结束（取最小和最大值，兼容正序/倒序拖拽）
                    const start = Math.min(first, last);
                    const end = Math.max(first, last);

                    // 填充范围内所有缺失的元素
                    for (let i = start; i <= end; i++) {
                        if (!arr.includes(i)) {
                            arr.push(i);
                        }
                    }
                }
            }
            if (type) {
                this.draggedElements2 = arr
            } else {
                this.draggedElements = arr

            }
        },

        onMouseUp(item, type) {
            if (this.isDragging) {
                this.handleDragEnd(type);
            } else {
                this.handleClick(item, type);
            }

            // 重置状态
            this.isDragging = false;
            this.isMouseDown = false;

            this.draggedElements = []
            this.draggedElements2 = []
        },

        handleMouseLeave(type) {
            if (this.isDragging) {
                this.handleDragEnd(type)
                // 重置状态
                this.isDragging = false
                this.isMouseDown = false
                this.draggedElements = []
                this.draggedElements2 = []
            }
        },

        handleDragEnd(type) {
            // 去重并排序拖拽经过的元素
            let arr = type ? this.draggedElements2 : this.draggedElements
            let arr2 = type ? this.noConsumeExecuteTimeSegments : this.noOrderExecuteTimeSegments
            const uniqueElements = [...new Set(arr)].sort((a, b) => a - b);
            // 判断是否需要选中还是取消选中（全选则取消，否则选中）
            const allSelected = uniqueElements.every(el => arr2.includes(el));

            // console.log(allSelected, 'allSelected')
            if (allSelected) {
                // 取消选中：从活跃列表中移除拖拽元素
                arr2 = arr2.filter(
                    el => !uniqueElements.includes(el)
                );
            } else {
                // 选中：添加拖拽元素（去重）
                uniqueElements.forEach(el => {
                    if (!arr2.includes(el)) {
                        arr2.push(el);
                    }
                });
            }

            // 最终排序
            arr2.sort((a, b) => a - b);
            console.log(arr2)
            if (type) {
                this.noConsumeExecuteTimeSegments = arr2
            } else {
                this.noOrderExecuteTimeSegments = arr2

            }
        },
        handleClick(item, type) {
            let arr = type ? this.noConsumeExecuteTimeSegments : this.noOrderExecuteTimeSegments
            const index = arr.indexOf(item);
            if (index === -1) {
                arr.push(item);
            } else {
                arr.splice(index, 1);
            }
            arr.sort((a, b) => a - b);
            if (type) {
                this.noConsumeExecuteTimeSegments = arr
            } else {
                this.noOrderExecuteTimeSegments = arr

            }
        },
        closeRulePopup() {
            this.editData = {}
            this.selectedDYNumber = ''
            this.selectedAccount = ''
            this.planWhiteList = []
            this.planWhiteListOptions = []
            this.selectData = ''
            this.loading = false
            this.isSearching = false
            this.activeMarketingBox = 0
            this.monitor1 = true
            this.monitor2 = true
            this.judgeValue = ""
            this.noOrderContinuousDays = 1
            this.noOrderTotalOrders = 0
            this.noOrderRebuildWithOriginalParams = false
            this.noOrderRoiAdjustType = '降低'
            this.noOrderRoiTarget = ''
            this.noConsumeContinuousDays = 1
            this.noConsumeTotalAmount = 0
            this.noConsumeRebuildWithOriginalParams = false
            this.noConsumeRoiAdjustType = '降低'
            this.noConsumeRoiTarget = ''
            this.activeWayBoxIndex = 0
            this.searchKeyWord = ''
            this.checkAll = false
            this.checkedAccount = []
            this.monitorList = this.accountList
            this.selectedMonitorList = []
            this.wxContracts = []
            this.activeTimePeriodBox = 0
            this.activeTimePeriodBox2 = 0
            this.noOrderExecuteTimeSegments = []
            this.noConsumeExecuteTimeSegments = []
            this.wxNotice = true
            this.isLimitWXNotice = false
            this.wxNoticeTimeValue = 30
            this.isPromotionEnabled = true
            this.maxDailyRebuildPerAccount = 500
            this.monitorStatus = '启用'
            this.ruleName = ''
            this.selectAgentId = ''

            this.showAddCreateRulePopup = false

        },
        // 处理选择时间
        pickData(e) {
            console.log(e)
            if (e) {
                console.log(e, '233')
                console.log(this.selectData, '233')
                const year_start = e[0].getFullYear()
                const month_start = String(e[0].getMonth() + 1).padStart(2, '0')
                const day_start = String(e[0].getDate()).padStart(2, '0')
                this.startTime = `${year_start}-${month_start}-${day_start}`
                const inputDate = new Date(e[1])
                this.endTime = this.processDate(inputDate)
                console.log(this.startTime, this.endTime, '233')
            } else {
                this.startTime = ''
                this.endTime = ''
                console.log(this.startTime, this.endTime, '233')
            }
            if (this.selectedAccount) {
                this.getPlanList()
            }
        },
        processDate(targetDate) {
            const now = new Date();
            // 创建目标日期的纯日期部分（去除时间）
            const targetDateOnly = new Date(
                targetDate.getFullYear(),
                targetDate.getMonth(),
                targetDate.getDate()
            );

            // 创建当前日期的纯日期部分（去除时间）
            const todayOnly = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate()
            );

            console.log(targetDateOnly.getTime() === todayOnly.getTime(), now, '555555')
            if (targetDateOnly.getTime() === todayOnly.getTime()) {
                // 如果是今天：返回当前完整时间（年月日时分秒）

                const year = now.getFullYear()
                const month = String(now.getMonth() + 1).padStart(2, '0')
                const day = String(now.getDate()).padStart(2, '0')
                // const hours = String(now.getHours()).padStart(2, '0')
                // const minutes = String(now.getMinutes()).padStart(2, '0')
                // const seconds = String(now.getSeconds()).padStart(2, '0')
                return `${year}-${month}-${day}`
            } else {
                const year_end = targetDate.getFullYear()
                const month_end = String(targetDate.getMonth() + 1).padStart(2, '0')
                const day_end = String(targetDate.getDate()).padStart(2, '0')
                return `${year_end}-${month_end}-${day_end}`
            }
        },
        goAddRule() {
            if (!this.selectedMonitorList.length) {
                let name = this.activeWayBoxIndex ? this.activeWayBoxIndex == 1 ? '计划'
                    :
                    this.activeWayBoxIndex == 2 ? '抖音号' : '商品' : '账户'
                this.$message.error('请选择广告' + name)
                return
            }


            if (this.monitor1) {
                if (!this.noOrderTotalOrders && this.noOrderTotalOrders !== 0) {
                    this.$message.error('执行内容参数不能为空')
                    return
                }
                if (this.noOrderRebuildWithOriginalParams) {
                    if (!this.noOrderRoiTarget) {
                        this.$message.error('执行内容参数不能为空')
                        return
                    }
                }
            }


            if (this.activeTimePeriodBox) {
                if (!this.noOrderExecuteTimeSegments.length) {
                    this.$message.error('请选择时间')
                    return
                }
            }



            if (this.monitor2) {
                if (!this.noConsumeTotalAmount && this.noConsumeTotalAmount !== 0) {
                    this.$message.error('执行内容参数不能为空')
                    return
                }
                if (this.noConsumeRebuildWithOriginalParams) {
                    if (!this.noConsumeRoiTarget) {
                        this.$message.error('执行内容参数不能为空')
                        return
                    }
                }
            }


            if (this.activeTimePeriodBox2) {
                if (!this.noConsumeExecuteTimeSegments.length) {
                    this.$message.error('请选择时间')
                    return
                }
            }

            if (!this.maxDailyRebuildPerAccount) {
                this.$message.error('重建设置内容不能为空')
                return

            }

            if (!this.wxNotice) {
                this.$message.error('请选择通知方式')
                return

            }

            if (!this.wxContracts.length) {
                this.$message.error('请选择联系人')
                return

            }

            if (!this.ruleName) {
                this.$message.error('请输入规则名称')
                return

            }

            if (!this.selectAgentId) {
                this.$message.error('请选择代理')
                return
            }

            let ids = []
            this.selectedMonitorList.forEach((obj) => {
                if (!this.activeWayBoxIndex) {
                    ids.push(obj.advertiserId)
                } else if (this.activeWayBoxIndex == 1) {
                    ids.push(obj.adId)
                } else if (this.activeWayBoxIndex == 2) {
                    ids.push(obj.id)
                } else if (this.activeWayBoxIndex == 3) {
                    ids.push(obj.id)
                }
            })
            let noticeConfig = {  //通知设置，如通知设置传0则为不通知
                wxNumber: this.wxContracts,  //通知微信号
                interval: this.isLimitWXNotice ? this.wxNoticeTimeValue : 0  //限制的通知频率，为0则不限制
            }

            let executeContent = {
                monitorObjectInfo: buildMonitorObjectInfo(this.selectedMonitorList, this.planWhiteList),
                isPromotionEnabled: this.isPromotionEnabled,
                maxDailyRebuildPerAccount: this.maxDailyRebuildPerAccount
            }
            if (this.monitor1) {
                executeContent.noOrderContinuousDays = this.noOrderContinuousDays
                executeContent.noOrderTotalOrders = this.noOrderTotalOrders
                executeContent.noOrderRebuildWithOriginalParams = this.noOrderRebuildWithOriginalParams
                executeContent.noOrderRoiAdjustType = this.noOrderRoiAdjustType
                executeContent.noOrderRoiTarget = this.noOrderRoiTarget
                executeContent.noOrderExecuteTimeSegments = this.activeTimePeriodBox ? this.noOrderExecuteTimeSegments : [0]   //执行时段2 为0则为不限时
            }


            if (this.monitor2) {
                executeContent.noConsumeContinuousDays = this.noConsumeContinuousDays
                executeContent.noConsumeTotalAmount = this.noConsumeTotalAmount
                executeContent.noConsumeRebuildWithOriginalParams = this.noConsumeRebuildWithOriginalParams
                executeContent.noConsumeRoiAdjustType = this.noConsumeRoiAdjustType
                executeContent.noConsumeRoiTarget = this.noConsumeRoiTarget
                executeContent.noConsumeExecuteTimeSegments = this.activeTimePeriodBox2 ? this.noConsumeExecuteTimeSegments : [0]   //执行时段2 为0则为不限时段
            }
            const now = new Date();
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            let monitoringTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

            if (this.editData.monitoringTime) {
                executeContent.monitoringTime = this.editData.monitoringTime
            } else {
                executeContent.monitoringTime = monitoringTime
            }
            console.log(executeContent)
            let data = {
                userId: this.selectAgentId,
                ruleName: this.ruleName,
                marketingTarget: 0,
                monitorType: this.activeWayBoxIndex + 1,
                status: 1,
                monitorObject: ids,
                planWhitelist: JSON.stringify(this.planWhiteList),
                monitorObjectInfo: this.selectedMonitorList,
                executeContent: JSON.stringify(executeContent),
                noticeConfig: JSON.stringify(noticeConfig),
                intelligentRegulationType: 4,
                monitorAdvertiserId: this.selectedAccount,
            }
            console.log(data)
            let url
            if (this.editData.id) {
                data.id = this.editData.id
                url = 'smartRoiRules/update'
            } else {
                url = 'smartRoiRules/add'
            }
            this.$axios.post({
                url: url,
                data,
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.closeRulePopup()
                        this.$refs.table.getData()
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }


                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })


        },
        handleCheckAllChange(e) {
            console.log(e)
            this.checkedAccount = e ? this.monitorList : []
            this.selectedMonitorList = this.checkedAccount
            this.isIndeterminate = false
            console.log(this.isIndeterminate, 'this.isIndeterminate')
        },
        handleCheckedCitiesChange(e) {
            console.log(e)
            this.selectedMonitorList = e
            this.checkAll = e.length === this.monitorList.length
            this.isIndeterminate = e.length > 0 && e.length < this.monitorList.length
        },
        deleteSelectedMonitorList(index) {
            console.log(index, index)
            if (index === '') {
                this.handleCheckAllChange(false)
            } else {
                this.checkedAccount = this.checkedAccount.slice(0, index).concat(this.checkedAccount.slice(index + 1));
                this.selectedMonitorList = this.checkedAccount
            }
            this.checkAll = false
        },

        goSelectMonitorWay(index) {
            this.activeWayBoxIndex = index
            this.monitorList = []
            this.selectedMonitorList = []
            this.selectedAccount = ''
            this.searchKeyWord = ''
            this.isSearching = false
            this.searchMonitorList = []
            this.checkedAccount = []
            this.checkAll = false
            this.planWhiteList = []
            this.planWhiteListOptions = []

            if (!this.activeWayBoxIndex) {
                this.getADAccountList()

            }
        },

        goSearchMonitorList(type) {
            if (!this.searchKeyWord) return
            this.isSearching = true
            this.searchMonitorList = []
            if (!type) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.advertiserId).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 1) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.adId).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 2) {
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.id).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            } else if (type == 3) {
                console.log(this.monitorList)
                this.monitorList.forEach((obj) => {
                    if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.id).includes(this.searchKeyWord)) {
                        this.searchMonitorList.push(obj)
                    }
                })
            }
            console.log(this.searchMonitorList)

        },
        returnId(data) {
            this.selectIds = data;
            console.log(this.selectIds)
        },
        addCreateRule() {
            this.showAddCreateRulePopup = true;
        },
        getADAccountList() {
            this.$axios.post({
                url: '/oceanEngineAdvertiser/getAllInfo',
                success: (res) => {
                    console.log('333', res)
                    this.accountList = res.data
                    this.monitorList = this.accountList
                },
                error: () => {
                    this.$message.error('出错了')
                },
            })
        },
        getDataByAccount(type) {
            if (type) {
                this.getdyNumberList()

            } else {
                this.getPlanList()
            }

        },
        getPlanList() {
            this.monitorList = []
            this.loading = true
            let data = {
                advertiserId: this.selectedAccount,
                smart_bid_type: 'SMART_BID_CUSTOM',
                pageIndex: 1,
                pageSize: 100
            }
            if (this.endTime) {
                data.create_start_date = this.startTime
            }
            if (this.startTime) {
                data.create_end_date = this.endTime
            }
            console.log(data, 'data------')
            this.$axios.post({
                url: 'uniPromotion/listByCondition',
                data,
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.planList = res.data.content
                        this.monitorList = this.planList
                        this.mergePlanWhiteListOptions(this.planList)
                        if (this.selectedMonitorList.length && this.activeWayBoxIndex == 1) {
                            let arr = []
                            this.selectedMonitorList.forEach((obj) => {
                                let adIndex = this.planList.findIndex((ad) => ad.adId == obj.adId)
                                if (adIndex !== -1) {
                                    arr.push(this.planList[adIndex])
                                }
                            })
                            this.checkedAccount = arr
                            this.handleCheckedCitiesChange(arr)
                        }
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }

                    //
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        getProductList(type) {
            this.checkAll = false
            this.selectedMonitorList = []
            this.searchKeyWord = ''
            this.isSearching = false
            this.searchMonitorList = []
            this.monitorList = []
            this.loading = true
            console.log(this.selectedAccount, this.selectedDYNumber)
            let object = {
                advertiserId: this.selectedAccount,
                aweMeId: this.selectedDYNumber,
                isAll: true,
            }
            console.log(object)
            this.$axios.post({
                url: '/launchTheProduct/getProductList',
                data: object,
                success: (res) => {
                    this.loading = false
                    console.log(res);
                    if (res.code === 0) {
                        console.log(res)
                        this.monitorList = res.data.productList
                        if (type) {
                            this.getdyNumberList(1)
                        }
                    } else {
                        this.$message.error(res.msg)
                        this.loading = false
                    }
                }
            })

        },
        getdyNumberList(type) {
            if (!type) {
                this.monitorList = []
            }

            this.loading = true
            this.$axios.get({
                url: '/oceanEngineAdvertiser/getAllInfoAndDouYin/' + this.selectedAccount,
                success: (res) => {
                    console.log(res, '222')
                    this.loading = false
                    if (res.code === 0) {
                        this.dyNumberList = res.data
                        if (type) return
                        this.monitorList = res.data
                        if (this.selectedMonitorList.length && this.activeWayBoxIndex == 2) {
                            let arr = []
                            this.selectedMonitorList.forEach((obj) => {
                                let adIndex = this.dyNumberList.findIndex((ad) => ad.id == obj.id)
                                if (adIndex !== -1) {
                                    arr.push(this.dyNumberList[adIndex])
                                }
                            })
                            this.checkedAccount = arr
                            this.handleCheckedCitiesChange(arr)
                        }
                    } else {
                        this.$message.error(res.msg || '获取数据错误')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
    }
}
</script>

<style scoped>
@import "../../styles/ocean-engine-rule-drawer.css";

* {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.createRuleTitle {
    font-weight: 600;
}

.createRuleTitle i {
    cursor: pointer;
}

.setRuleContent {
    overflow: scroll;
    height: 90vh;
}


/* 营销目标 */

.marketingBox {
    padding: 8px 20px;
    color: #ddd;
    cursor: not-allowed;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-left: none;
    border-radius: 0 5px 5px 0;
}

.marketingObjectives_box div:first-child {
    border-radius: 5px 0 0 5px;
}

.activeMarketingBox {
    background-color: #409eff;
    color: #fff;
}



.monitorWayBox,
.monitorTargetBox {
    padding: 14px 20px;
}

.monitorWayBox i {
    color: #409eff;
}

.monitorWayBox .way_box {
    cursor: pointer;
    width: 220px;
    /* height: 80px; */
    padding: 20px 0;
    border: 1px solid #ddd;
    color: #333;
    border-radius: 5px;
}

.monitorWayBox .way_info {
    color: #666;
}

.active_way_box {
    border-color: #346bf6 !important;
    color: #346bf6 !important;
}

.monitorTargetBox .monitorTargetContent {
    background-color: #f9f9f9;
    border-radius: 5px;
    padding: 15px;
}


/deep/ .monitorTargetBox .monitorTargetContent .el-button {
    border-radius: 0 50px 50px 0;
    height: 36px;
    width: 70px;
}


.handle-input2 {
    width: 300px !important;
    height: 36px;
    box-sizing: border-box;
}

/deep/ .handle-input2 .el-input__inner {
    height: 36px !important;
    box-sizing: border-box;
}


.selectTitleBox .leftTitle,
.rightTitle {
    font-size: 15px !important;
    /* font-weight: 600 !important; */
    width: 50%;
    background-color: #f0f2f5;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
}

.selectContentBox {
    background-color: #fff;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
}


.selectContentBox .accountBox {
    height: 30px;
}

.selectContentBox .left {
    width: 50%;
    padding: 10px;
    height: 250px;
    overflow: scroll;
}


.productImg {
    height: 50px;
    width: 50px;
    border-radius: 5px;
}


.selectContentBox .nodata {
    /* width: 100%; */
    padding: 10px;
    height: 90%;
}


.selectedAccountBox {
    background-color: #edf4ff;
    padding: 10px;
}

.selectedAccountBox i {
    color: #409eff;
    cursor: pointer;
}

.yuan_box {
    position: absolute;
    top: 5px;
    right: 5px;
}

.addCondition {
    background-color: #edf4ff;
    padding: 5px 0;
    width: 500px;
    color: #4389f9;
    cursor: pointer;
}

.w100 {
    width: 100px;
}

.w150 {
    width: 150px;
}


.timePeriodBox {
    border: 1px solid #ddd;
    padding: 5px 30px;
    color: #555;
    cursor: pointer;
}

.activeTimePeriodBox {
    background-color: #409eff;
    color: #fff;
}



.yl-time-range-table {
    border-collapse: collapse;
    table-layout: fixed;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 4px;
    width: 773px;
    border: 1px solid #e4e9ed;
    background-color: #fff;
}

.table_head {
    background-color: #f0f2f5;
    color: #555;
    /* padding: 10px; */
    /* width: 600px; */
    text-align: center;
}

.time_select_box {
    height: 40px !important;
    cursor: pointer;
    /* width: 20px !important; */
}

.time_select_box_inactive:hover {
    background-color: #f0f2f5;
}

.time_select_box_active {
    background-color: #409eff;
}

.time_select_box_active2 {
    background-color: rgba(64, 158, 255, 0.7);
    border-color: rgba(64, 158, 255, 0.7);
}


.drawer_footer {
    z-index: 1;
    background: #fff;
    align-items: center;
    height: 64px;
    padding: 0 20px;
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -4px 6px #00000014;
}

.content_box1 {
    border: 1px dashed #ccc;
    padding: 20px 30px;

}

.currentPeriodBox {
    background-color: #e5ebf9;
    padding: 5px 10px;
    border-radius: 5px;
}

.timePeriodBox {
    border: 1px solid #ddd;
    padding: 5px 30px;
    color: #555;
    cursor: pointer;
}

.activeTimePeriodBox {
    background-color: #409eff;
    color: #fff;
}


/* /deep/ .selectContentBox .checkBox .el-checkbox__inner {
    margin-bottom: 15px !important;
} */

/deep/ .input100 .el-input__inner {
    width: 100px;
}


/deep/ .input120 .el-input__inner {
    width: 120px;
}

/deep/ .input150 .el-input__inner {
    width: 150px;
}

/deep/ .input200 .el-input__inner {
    width: 200px;
}

/deep/ .input_h35 .el-input__inner {
    height: 35px !important;
}

/deep/ .input400 .el-input__inner {
    width: 400px !important;
}



@media (max-width: 768px) {

    .monitorWayBox,
    .monitorTargetBox,
    .marketingObjectives {
        padding: 15px;
    }

    .monitorWayBox .way_box {
        font-size: 14px;
        width: 20vw;
        box-sizing: border-box;
        height: 100px;
        /* height: 80px; */
        padding: 10px 5px;
    }


    .handle-input2 {
        font-size: 14px;
        width: 200px !important;
        height: 36px;
    }


    .addCondition {
        width: 300px;
    }

    .yl-time-range-table {
        width: 300px;
    }

    .dateSelector {
        transform: scale(0.8) !important;
        margin-left: -40px !important;
    }

    .productImg {
        height: 30px;
        width: 30px;
    }

    .selectedAccountBox {
        padding: 3px;
    }


    .content_box1 {
        padding: 10px 10px;

    }
}
</style>
